import { Controller } from "stimulus"
import validate from "validate.js"

const CLASS_NOT_VALID = 'mail-is-not-valid';
const CLASS_HAS_VALUE = 'has-value';
const CLASS_MSG_ACTIVE = 'is-msg-active';
const CLASS_IS_FOCUSED = 'is-focused';

export default class extends Controller {
    static targets = [ 'inputItem', 'msg', 'msgWrap', 'newsletter', 'submitSpinner', 'submitBtn'];
    inputItems = [];

    initialize() {
        this.submit = this.submit.bind(this);
        this.sendSuccess = this.sendSuccess.bind(this);
        this.sendError = this.sendError.bind(this);
    }

    connect() {
        this.submitSpinnerTarget.style.display = 'none';
        this.url = this.element.getAttribute('action');
        this.element.addEventListener('submit', this.submit);

        this.inputItemTargets.forEach((itemTarget) => {
            const input = itemTarget.querySelector('input');
            const required = input.getAttribute('required');
            const type = input.getAttribute('data-type');

            const item = {
                self: itemTarget,
                input: input,
                required: required,
                type: type,
                valid: true,
            };

            this.inputItems.push(item);

            input.addEventListener('focus', (e) => {
                itemTarget.classList.add(CLASS_IS_FOCUSED);
            });

            input.addEventListener('blur', (e) => {
                itemTarget.classList.remove(CLASS_IS_FOCUSED);

                if (item.input.value !== '') {
                    itemTarget.classList.add(CLASS_HAS_VALUE);
                    this.validateValue(item);
                } else {
                    itemTarget.classList.remove(CLASS_HAS_VALUE);
                }
            });

            input.addEventListener('input', (e) => {
                if (!item.valid) {
                    this.validateValue(item);
                }
            });
        });
    }

    submit(e) {
        e.preventDefault();
        this.msgTarget.classList.add(CLASS_MSG_ACTIVE);

        if(!this.validateAll()) {
            this.msgWrapTarget.innerHTML = "<p>Please fix errors above</p>";
            return;
        } else {
            this.sendData();
            return false;
        }
    }

    sendData() {
        this.submitSpinnerTarget.style.display = '';
        this.newsletterTarget.style.display = 'none';

        const data = new FormData(this.element);

        fetch(this.url, {
            method: 'post',
            body: data,
            headers: {
                'Accept' : 'application/json',
                'x-requested-with' : 'XMLHttpRequest'
            }
        })
        .then((response) => {
            this.sendSuccess();
        });
    }

    sendSuccess() {
        this.submitSpinnerTarget.style.display = 'none';
        this.msgWrapTarget.innerHTML = `<p>Thanks!<br> You're all signed up.<p>`;
    }

    sendError() {

    }

    validateAll() {
        let isValid = true;
        this.inputItems.forEach((item) => {
            let notValid = this.validateValue(item);
            if (notValid) {
                isValid = false;
            }
        });
        return isValid;
    }

    validateValue(item) {
        const target = item.self;
        const value = item.input.value;
        const required = item.required;
        const type = item.type;

        let constraints = { 'field' : {}};

        if (required !== null) {
            constraints.field.presence = { allowEmpty: false };
        }

        if (type === 'email') {
            constraints.field.email = true;
        }

        let notValid = validate({field: value}, constraints);

        if (notValid) {
            item.valid = false;
            target.classList.add(CLASS_NOT_VALID);
        } else {
            item.valid = true;
            target.classList.remove(CLASS_NOT_VALID);
        }

        return notValid;
    }
}



// WEBPACK FOOTER //
// ./mysite/resources/js/controllers/applications-form_controller.js